import React from "react";
import styled from "styled-components";

const Card = styled.div`
  --bg: #f9f9f9;
  --hover-bg:${props => props.theme.colors.primaryLight};
  --hover-text:${props => props.theme.colors.primary};
  max-width: 23ch;
  text-align: center;
  background: var(--bg);
  padding: 1.5em;
  padding-block: 1.8em;
  border-radius: 5px;
  position: relative;
  overflow: hidden;
  transition: 0.3s cubic-bezier(0.6, 0.4, 0, 1), transform 0.15s ease;
  /*box-shadow: 3px 3px 2px 0px rgba(4, 28, 64, 1);*/
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 1em;

  &:hover {
    background: var(--hover-bg);
  }

  &:hover span {
    top: 0;
    font-size: 1.2em;
  }

  &:hover > div,
  &:hover > strong {
    opacity: 0;
  }
`;

const Icon = styled.div`
  svg {
    height: 24px;
    width: 24px;
    color:${props => props.theme.colors.secondary};
  }
`;

const CardBody = styled.div`
  color:${props => props.theme.colors.primary};
  line-height: 1.5em;
  font-size: 0.5em;
`;

const CardTitle = styled.strong`
  display: block;
  font-size: 1.4rem;
  letter-spacing: -0.035em;
  color:${props => props.theme.colors.secondary};
`;

const CardHover = styled.span`
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: var(--hover-text);
  border-radius: 5px;
  font-weight: bold;
  top: 100%;
  transition: all 0.3s cubic-bezier(0.6, 0.4, 0, 1);
`;

const stile={
  "background-image":" linear-gradient(to right bottom, rgba(4, 28, 64, 1); 30%,#f7bc0c 50%, #fff 20%)",
  "position": "absolute",
   " top": "-30px",
    "left": "-30px",
    "width": "200px",
    "height": "200px",
    "background": "-webkit-gradient(linear, left top, right top, from(#2336b6), to(rgba(31, 38, 103, 0.9)))",
    "background": "linear-gradient(to right, #2336b6, rgba(31, 38, 103, 0.9))",
    "-webkit-transform": "rotate(-45deg)",
    "transform": "rotate(-45deg)",
    "-webkit-transition": "all 250ms ease-out",
    "transition": "all 250ms ease-out",
}

const CardTwo = ({title,description,image}) => {
  return (
    <Card>
      <Icon>
        {image}
      </Icon>
      <CardTitle>{title}</CardTitle>
      {/*<CardBody>Get UI elements that help you stand out.</CardBody>*/}
      <CardHover><CardBody>{description}</CardBody></CardHover>
    </Card>
  );
};

export default CardTwo;
